import {listener} from "../../../../../modules/vegas/js/util";
import CategoryNav from "../categories/categories-nav";

listener('vg.sidebar.loaded', '#sidebar-catalog', (el, e) => {
	let categoryNavElement = el.querySelector('#categories-nav-container');
	if (categoryNavElement) {
		window.categoryNav = new CategoryNav(categoryNavElement);
	}
});
